import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Label } from '@/components/ui/label';

interface ProviderFieldProps {
  label: string;
  htmlFor?: string;
  hint?: string;
  error?: string;
  isRequired?: boolean;
  children: ReactNode;
}

export function ProviderField({
  label,
  htmlFor,
  hint,
  error,
  isRequired = false,
  children,
}: ProviderFieldProps) {
  const { t } = useTranslation('notifications');
  const hasError = error !== undefined && error.length > 0;
  const hasHint = hint !== undefined && hint.length > 0;
  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor={htmlFor}>
        {label}
        {isRequired ? (
          <span className="text-zooerrortext" title={t('providers.required')}>
            {' *'}
          </span>
        ) : null}
      </Label>
      {children}
      {hasHint && hasError === false ? <span className="text-xs text-zoomuted">{hint}</span> : null}
      {hasError ? <span className="text-xs text-zooerrortext">{error}</span> : null}
    </div>
  );
}
